export const handleEnterKey = (onEnter) => (e) => {
  if (e.key === 'Enter') {
    e.preventDefault()
    onEnter()
  }
}
